var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('form-information-rvs'),_c('form-alarm-management'),_c('form-raw-vibration-sensor'),_c('form-diagram-rvs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }